module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap-modal",
    attrs: {
      "modal": ""
    }
  }, [_c('div', {
    staticClass: "scrim"
  }), _vm._v(" "), _c('div', {
    staticClass: "wrap_visible_block"
  }, [_c('div', {
    staticClass: "wrap_background"
  }, [_c('div', {
    staticClass: "wrap-criss-cross",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('svg', {
    staticClass: "criss-cross",
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('polygon', {
    attrs: {
      "points": "8.5,7 7,8.5 10.5,12 7,15.5 8.5,17 12,13.5 15.5,17 17,15.5 13.5,12 17,8.5 15.5,7 12,10.5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "wrap_content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "btn primary",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n          " + _vm._s(_vm.getDeftextBtnPrimary) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn faq",
    attrs: {
      "href": "https://multiplex.ua/ua/faq"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.getDeftextBtnSecondary))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4d43292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pop-ups/modal-popup.vue
// module id = 436
// module chunks = 1